import axios from '@/service/request';
import type { R, BuyerRegisterTypeEnum, BuyerRegisterSourceEnum, ChannelTypeEnum } from './types';

/**
 * 用户查询请求参数
 */
export interface BuyerQueryRequest {
  /** 用户id */
  buyerId?: string;
  /** 用户账号 */
  account?: string;
  /** 用户在微信体系下唯一id */
  unionId?: string;
  /** openId */
  openId?: string;
  /** 用户注册类型 */
  registerType?: BuyerRegisterTypeEnum;
}

/**
 * 用户详情响应数据
 */
export interface BuyerDetailResponse {
  /** 用户id */
  buyerId?: string;
  /** 创建时间 */
  createTime?: string;
  /** 修改时间 */
  updateTime?: string;
  /** 账号 */
  account?: string;
  /** 手机 */
  mobile?: string;
  /** 邮箱 */
  email?: string;
  /** 密码 */
  password?: string;
  /** 密码加盐 */
  passwordSalt?: string;
  /** openId */
  openId?: string;
  /** unionId */
  unionId?: string;
  /** 用户注册类型 */
  registerType?: BuyerRegisterTypeEnum;
  /** 用户注册来源 */
  registerSource?: BuyerRegisterSourceEnum;
  /** 用户注册渠道 */
  registerChannel?: ChannelTypeEnum;
  /** 微信昵称 */
  nickname?: string;
  /** 真实姓名 */
  realName?: string;
  /** 身份证号 */
  idCard?: string;
  /** 用户头像 */
  headimgurl?: string;
  /** 国家编码. 如中国为CN */
  country?: string;
  /** 性别 1男 2女 3未知 */
  gender?: number;
}

/**
 * 用户详情
 */
export const apiBuyerDetail = (data: BuyerQueryRequest): Promise<R<BuyerDetailResponse>> => {
  return axios.post('/buyer/detail', data);
};

